// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3Q8ZV","buttons":"RemoveExpirationActionButtons_buttons__32mPv"};